import sendChatMessageReducer from '../../slices/chat/SendChatMessage';
import fetchHistoryReducer from '../../slices/chat/FetchHistory';
import clearChatHistoryReducer from '../../slices/chat/ClearChatHistory';

const chatReducer = {
    chatSend: sendChatMessageReducer,
    chatHistory: fetchHistoryReducer,
    clearChatHistory: clearChatHistoryReducer,
};

export default chatReducer;